var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Graphic-Style-10,.cls-8{fill:none;stroke:#493555;stroke-linecap:round;stroke-linejoin:round;}.Graphic-Style-10{stroke-width:6px;}.cls-1{fill:#ffeb73;}.Graphic-Style-9{fill:#493555;opacity:0.24;}.cls-2{fill:#726d77;}.cls-3{fill:#f4b86f;}.cls-4{fill:#25db7e;}.cls-5{fill:#84ccfc;}.cls-6,.cls-7{fill:#fff;}.cls-6{opacity:0.44;}.cls-8{stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "snowglobe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Graphic-Style-10",
    d: "M102.31,86.67A4.006,4.006,0,0,0,98.32,83H95.51a39,39,0,1,0-63.02,0H29.68a4.006,4.006,0,0,0-3.99,3.67l-1.33,16A4,4,0,0,0,28.35,107h71.3a4,4,0,0,0,3.99-4.33Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48,
    y: 91,
    width: 32,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Graphic-Style-9",
    x: 48,
    y: 95,
    width: 32,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.64,102.67A4,4,0,0,1,99.65,107H28.35a4,4,0,0,1-3.99-4.33l1.33-16A4.006,4.006,0,0,1,29.68,83H98.32a4.006,4.006,0,0,1,3.99,3.67ZM80,99V91H48v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic-Style-9",
    d: "M99.65,103H28.35a4,4,0,0,1-3.79-2.731l-.2,2.4A4,4,0,0,0,28.35,107h71.3a4,4,0,0,0,3.99-4.33l-.2-2.4A4,4,0,0,1,99.65,103Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60,
    y: 73,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "49.33 65 52 61 46 61 48.86 57 53.14 51 56 47 50 47 53.29 43 64 30 74.71 43 78 47 72 47 73.52 49.12 74.86 51 79.14 57 82 61 76 61 77.39 63.09 78.67 65 84 73 44 73 49.33 65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-9",
    points: "68 69 60 69 46.667 69 44 73 60 73 68 73 84 73 81.333 69 68 69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-9",
    points: "77.39 63.09 49.33 65 52 61 76 61 77.39 63.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-9",
    points: "78 47 50 47 53.29 43 74.71 43 78 47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-9",
    points: "82 61 46 61 48.86 57 79.14 57 82 61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-9",
    points: "73.52 49.12 53.14 51 56 47 72 47 73.52 49.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103,60a38.866,38.866,0,0,1-7.49,23H68V73H84L76,61h6L72,47h6L64,30,50,47h6L46,61h6L44,73H60V83H32.49A39,39,0,1,1,103,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic-Style-9",
    d: "M94,60a40.22,40.22,0,0,1-7.121,23H90.49A38.994,38.994,0,0,0,59,21c-.344,0-.684.017-1.026.026C77.957,21.572,94,38.805,94,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34,60a40.22,40.22,0,0,0,7.121,23H37.51A38.994,38.994,0,0,1,69,21c.344,0,.684.017,1.026.026C50.043,21.572,34,38.805,34,60Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 85,
    cy: 46,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 76,
    cy: 34,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 41,
    cy: 39,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 43,
    cy: 52,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 39,
    cy: 67,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 94,
    cy: 57,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 88,
    cy: 66,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 31,
    cy: 59,
    r: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-9",
    points: "68 75 60 77 60 73 68 73 68 75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68,83H98.32a4.006,4.006,0,0,1,3.99,3.67l1.33,16A4,4,0,0,1,99.65,107H28.35a4,4,0,0,1-3.99-4.33l1.33-16A4.006,4.006,0,0,1,29.68,83H60"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95.51,83a39,39,0,1,0-63.02,0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 48,
    y: 91,
    width: 32,
    height: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "68 73 84 73 76 61 82 61 72 47 78 47 64 30 50 47 56 47 46 61 52 61 44 73 60 73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 60,
    y: 73,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 52,
    y1: 61,
    x2: 76,
    y2: 61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 56,
    y1: 47,
    x2: 72,
    y2: 47
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72f90f6dc4e84093cef792a1e8e477dd.svg";
export { ForwardRef as ReactComponent };